module.exports = __webpack_public_path__ + "static/media/Slide58.0bcf698f.JPG";